import { Button } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { apisPath } from "../../../../utils/path";
import { authHttp } from "../../../services/utility";
import "../../../../../src/styles/Layout/Admin_Styles/_QuestionReport.scss";
import { useLocation } from "react-router-dom";
import { encrypt } from "../../../../utils/encryptDecrypt";
const QuestionReport = () => {
  const { setIsLoading, setAlertState } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const { state } = useLocation();

  useEffect(() => {
    if (state) {
      getData(state?.paper?.id);
    }
  }, [state]);

  const getData = (subject_id) => {
    setIsLoading(true);
    authHttp
      .get(
        `${apisPath?.admin?.questionWiseObjections}/${btoa(
          encrypt(subject_id)
        )}/${state?.type}`
      )
      .then((res) => {
        setData(res?.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const handlePrint = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.print(element);
    }
  };
  return (
    <div className="question-report" id="print">
      {data.length > 0 && (
        <div className="question-report--print">
          <Button variant="contained" onClick={() => handlePrint("print")}>
            Print
          </Button>
        </div>
      )}
      <div className="question-report--header">
        <h2>
          Online Objection on Answer Keys of Executive Officer and Tax & Revenue
          Inspector Exam-2023. <br /> अधिशासी अधिकारी एवं कर व राजस्व निरीक्षक
          परीक्षा-2023 की उत्तरकुंजियों के सापेक्ष ऑनलाइन आपत्ति दर्ज किये जाने
          हेतु आवेदन <br />
          Advertisement Number: - 01/E-02/DR/EO-TRI/2023
        </h2>
      </div>
      <div className="question-report--header">
        <h2>
          The answer options/question structure of the following questions have
          been considered appropriate/correct by the above-mentioned
          subject-experts
        </h2>
        <h3>
          status:{" "}
          <span
            className={`${
              state?.type?.toLowerCase() === "paid" ? "text-green" : "text-red"
            }`}
          >
            {state?.type}
          </span>
        </h3>
        <h3>
          subject: {state?.paper?.subject_desc} ({state?.paper?.subject_code})
        </h3>
      </div>
      <div className="question-report--table-wrapper">
        <table>
          <thead>
            <tr>
              <th>S No.</th>
              <th>Series-A Wise Q. No.</th>
              <th>Aayog Answer</th>
              <th>Answer According To Candidate(s)</th>
              <th>Answer According To Subject Expert</th>
              <th>Series-B Wise Q. No.</th>
              <th>Series-C Wise Q. No.</th>
              <th>Series-D Wise Q. No.</th>
            </tr>
          </thead>
          <tbody>
            {data.map((ques, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{ques?.series_a_wise_qno}</td>
                <td>{ques?.aayog_answer}</td>
                <td>{ques?.answer_according_to_candidates}</td>
                <td></td>
                <td>{ques?.series_b_wise_qno}</td>
                <td>{ques?.series_c_wise_qno}</td>
                <td>{ques?.series_d_wise_qno}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuestionReport;
